export default __webpack_public_path__ + "static/media/logo-colored.7a996ff9.svg";